import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '../../../components/button/Button';
import styled from 'styled-components';
import ItemService from '../../../services/ItemService';
import NotificationService from '../../../services/NotificationService';
import { useState } from 'react';
import { FavoriteItemGroupDTO } from '../../../api/api';

interface Props {
  handleClose: () => void;
  createGroupCallback: (newGroup: FavoriteItemGroupDTO) => void;
}

export default function CreateGroup(props: Props) {
  const { handleClose, createGroupCallback } = props;
  const [name, setName] = useState('');

  const submit = (e: any) => {
    e.preventDefault();
    ItemService.createFavoriteItemGroup(name)
      .then((res) => {
        createGroupCallback(res);
      })
      .catch(() => {
        NotificationService.error('Kunne ikke oprette gruppe.');
      })
      .finally(() => {
        handleClose();
      });
  };

  return (
    <Dialog open onClose={handleClose} PaperProps={{ component: 'form' }}>
      <DialogTitle>Opret gruppe</DialogTitle>
      <StyledDialogContent>
        <TextField
          autoFocus
          required
          margin="dense"
          id="name"
          label="Gruppenavn"
          fullWidth
          variant="standard"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </StyledDialogContent>
      <DialogActions>
        <Button variant="secondary" onClick={handleClose}>
          Annuller
        </Button>
        <Button onClick={submit}>Opret</Button>
      </DialogActions>
    </Dialog>
  );
}

export const StyledDialogContent = styled(DialogContent)`
  width: 350px;
`;
